import gql from 'graphql-tag'

// Activates a DRAFT variant once its dimensions and weight are present. The backend
// (inventory-api sc-536466 Phase 1) keeps activation explicit: updateItemMasterVariant
// fills the fields but leaves status DRAFT; only this mutation flips it to ACTIVE (and it
// is idempotent — a no-op if already ACTIVE). The Edit Variant flow calls this right after
// a successful update once the variant is complete, so "fill in weight + dimensions" reads
// as "completed" to the user.
export default gql`
	mutation ActivateItemMasterVariant($input: ActivateItemMasterVariantInput!) {
		activateItemMasterVariant(input: $input) {
			success
			message
			itemMaster {
				id
			}
		}
	}
`
